import axios from 'axios';
import { useAuth } from '@clerk/nextjs';
import { useMemo } from 'react';

const base = (process.env.NEXT_PUBLIC_API_URL || '').replace(/\/+$/, '');

if (!base) {
  console.error('NEXT_PUBLIC_API_URL is not set. API calls will fail.');
}

// Check if the URL already includes /v1 to avoid double versioning
const baseURL = base.endsWith('/v1') ? base : `${base}/v1`;

// Hook to get an authenticated API client
export function useAuthenticatedApiClient() {
  const { getToken } = useAuth();

  // Memoize the axios instance so its reference stays stable across renders.
  const apiClient = useMemo(() => {
    const client = axios.create({
      baseURL: baseURL || '/v1',
    });

    client.interceptors.request.use(async (config) => {
      try {
        if (getToken) {
          const token = await getToken();
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          }
        }
      } catch (error) {
        console.warn('Failed to get Clerk token:', error);
      }
      return config;
    });

    return client;
  }, [getToken]);

  return apiClient;
}
